<template>
  <span
    :class="
      (divClass || '') + (floatLabel ? ' p-float-label' : '') + ' p-fluid'
    "
  >
    <slot :id="stateId" :required="required" />

    <label :for="stateId" v-if="showLabel && label?.length">
      <i :class="iconClass" v-if="!!iconClass" style="margin-right: 0.25rem" />
      {{ label }}
      <small
        v-if="
          subLabel &&
            subLabel.length > 0 &&
            subLabel.length < 7 &&
            !forceSublabelUnder
        "
        v-text="'(' + subLabel + ')'"
        class="subLabel-inline"
      />
      <span v-if="required" class="required-mark" aria-label="obrigatório"
        >*</span
      >
      <slot name="complement" :id="stateId" :required="required" />
      <template v-if="addRequiredHiddenField && required">
        <input
          type="text"
          :value="hasValue ? 'hasValue' : ''"
          required
          tabindex="-1"
          class="hidden-input"
          :aria-label="label + ' validação'"
        />
      </template>
    </label>
    <label
      :for="stateId"
      v-if="subLabel && (subLabel.length >= 7 || forceSublabelUnder)"
      class="subLabel"
    >
      <small v-text="subLabel" class="subLabel-text" />
    </label>
  </span>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs, onMounted } from "vue";

interface InputWithLabelState {
  stateReady: boolean;
  stateId: string;
}

export default defineComponent({
  setup(props) {
    const state = reactive<InputWithLabelState>({
      stateReady: false,
      stateId:
        props.id ||
        "state-" +
          Math.random()
            .toString(36)
            .substring(2)
    });

    onMounted(async () => {
      state.stateReady = true;
    });

    return {
      ...toRefs(state)
    };
  },
  props: {
    iconClass: String,
    divClass: String,
    label: String,
    subLabel: String,
    required: [String, Number, Object, Boolean],
    id: String,
    floatLabel: {
      type: Boolean,
      default: true
    },
    forceSublabelUnder: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    addRequiredHiddenField: {
      type: Boolean,
      default: false
    },
    hasValue: {
      type: Boolean,
      default: false
    }
  },
  components: {}
});
</script>
<style scoped lang="scss">
.required-mark {
  color: $danger;
  font-weight: $font-weight-bold;
  margin-left: 2px;
}

.subLabel-inline {
  font-size: $font-size-xs;
  color: $text-muted;
}

.subLabel {
  font-size: $font-size-xs;
  color: $text-secondary;
  padding-top: 2px;
  bottom: 0.3rem;
  top: initial;
}

.subLabel-text {
  font-size: $font-size-xs;
  color: $text-secondary;
}

.p-float-label > .p-inputwrapper-filled ~ .subLabel,
.p-float-label > .p-inputwrapper-focus ~ .subLabel,
.p-float-label > input:focus ~ .subLabel,
.p-float-label > .p-filled ~ .subLabel {
  padding-top: 0 !important;
  bottom: -0.3rem !important;
  top: initial !important;
}
</style>
